'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _isIndexed = require('unmutable/lib/util/isIndexed');

var _isIndexed2 = _interopRequireDefault(_isIndexed);

var _isValueObject = require('unmutable/lib/util/isValueObject');

var _isValueObject2 = _interopRequireDefault(_isValueObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ParcelTypes = function ParcelTypes(value, parentParcelTypes, id) {
    var _this = this;

    (0, _classCallCheck3.default)(this, ParcelTypes);
    this._isChild = false;
    this._isElement = false;
    this._isIndexed = false;
    this._isParent = false;
    this._isTopLevel = false;

    this.isChild = function () {
        return _this._isChild;
    };

    this.isElement = function () {
        return _this._isElement;
    };

    this.isIndexed = function () {
        return _this._isIndexed;
    };

    this.isParent = function () {
        return _this._isParent;
    };

    this.isTopLevel = function () {
        return _this._isTopLevel;
    };

    this.toTypeCode = function () {
        var c = _this._isChild ? "C" : "c";
        var e = _this._isElement ? "E" : "e";
        var i = _this._isIndexed ? "I" : "i";
        var p = _this._isParent ? "P" : "p";
        var t = _this._isTopLevel ? "T" : "t";
        return '' + c + e + i + p + t;
    };

    this._isChild = !!parentParcelTypes;
    this._isElement = !!(parentParcelTypes && parentParcelTypes.isIndexed());
    this._isIndexed = (0, _isIndexed2.default)(value);
    this._isParent = (0, _isValueObject2.default)(value);
    this._isTopLevel = id.path().length === 0;
};

exports.default = ParcelTypes;


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcel/ParcelTypes.js
// module id = 742
// module chunks = 35783957827783